import { render } from "./RegistratiePopup.vue?vue&type=template&id=1373e40a&scoped=true"
import script from "./RegistratiePopup.vue?vue&type=script&lang=js"
export * from "./RegistratiePopup.vue?vue&type=script&lang=js"

import "./RegistratiePopup.vue?vue&type=style&index=0&id=1373e40a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1373e40a"]])

export default __exports__